export default {
  BRADFORD: [
    [ 0.8951000, 0.2664000, -0.1614000 ],
    [ -0.7502000, 1.7135000, 0.0367000 ],
    [ 0.0389000, -0.0685000, 1.0296000 ]
  ],
  INVERSE_BRADFORD: [
    [ 0.9869929, -0.1470543, 0.1599627 ],
    [ 0.4323053, 0.5183603, 0.0492912 ],
    [ -0.0085287, 0.0400428, 0.9684867 ]
  ],
  SRGB_XYZ: [
    [ 0.4124, 0.3576, 0.1805 ],
    [ 0.2126, 0.7152, 0.0722 ],
    [ 0.0193, 0.1192, 0.9505 ]
  ],
  INVERSE_SRGB_XYZ: [
    [ 3.2406, -1.5372, -0.4986 ],
    [ -0.9689, 1.8758, 0.0415 ],
    [ 0.0557, -0.2040, 1.0570 ]
  ]
}
